module.exports = __webpack_public_path__ + "img/newCaseTag.e17c0374.png";